import "../../sass/pages/game_ranking.scss";

// import { Week, WinnersProps, User } from '../types/apiRankingWeeks'

// import * as AOS from 'aos';
// import 'aos/dist/aos.css';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

window.addEventListener("load", () => {
  getRanking()
  // getRankingWeeks()
});

// https://mxstella.dp150.xyz/trivia/ranking-data

const userRanking = document.querySelector('.st_game_ranking--user')
const userPosition = document.querySelector('.user-position')
const userName = document.querySelector('.user-name')
const userScore = document.querySelector('.user-score')
const winners = document.querySelector('.st_game_ranking--winners')

const url_get = `${window.origin}/trivia/ranking-data`

const getRanking = async () => {
  const response = await fetch(url_get)
  const data = await response.json()
  // console.log(data);
  const { myRanking, ranking } = data
  
  if (!Array.isArray(myRanking)) {
    
    userName.textContent = `${myRanking.name} ${myRanking.lastname}`
    userScore.textContent = String(myRanking.points)
    userPosition.textContent = myRanking.position
    userRanking.classList.remove('hidden')
  
  }

  winners.innerHTML = '';
  winners.appendChild(renderWinnersTemplate(ranking));

}

export interface WinnersProps {
  score: string
  id: string
  updated_at: string
  created_at: string
  first_name: string
  last_name: string
}

const renderWinnersTemplate = (winners: WinnersProps[]) => {
  const fragment = document.createDocumentFragment();

  winners.forEach((winner, index) => {
    const listItem = document.createElement("li");
    listItem.className = "st_game_ranking--winners-item";

    const positionSpan = document.createElement("span");
    positionSpan.className = "winner-position";
    positionSpan.textContent = (index + 1).toString();
    listItem.appendChild(positionSpan);

    const nameSpan = document.createElement("span");
    nameSpan.className = "winner-name";
    nameSpan.textContent = `${winner.first_name} ${winner.last_name}`;
    listItem.appendChild(nameSpan);

    const scoreSpan = document.createElement("span");
    scoreSpan.className = "winner-score";
    scoreSpan.textContent = winner.score.toString();
    listItem.appendChild(scoreSpan);

    fragment.appendChild(listItem);
  });

  return fragment;
};